import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { DocumentTemplate } from '../models/document-template.model';
import { environment } from '../../../environments/environment';
import { IDvmsSystemAlert } from '../models/dvms-system-alerts.model';



@Injectable({
    providedIn: 'root'
})
export class DVMSSystemAlertsService {

    constructor(private http: HttpClient, private apiService: ApiService) { }
    public getAllDVMSSystemAlertsList(dvmsSystemAlertSearchParam: IGlobalSearchParam): Observable<any> {
        return this.apiService.post(`DVMSSystemAlert/SearchDvmsSystemAlert`, dvmsSystemAlertSearchParam)
    }
    public updateDVMSSystemAlerts(id: number, sysAlert: IDvmsSystemAlert): Observable<any> {
        return this.apiService.put(`DVMSSystemAlert/UpdateDvmsSystemAlert/${id}`, sysAlert);
      }
    public addDVMSSystemAlerts(sysAlert:IDvmsSystemAlert): Observable<any> {
        return this.apiService.post(`DVMSSystemAlert/CreateDvmsSystemAlert`,sysAlert);
    }
    public getDvmsSystemAlert(id:number):Observable<any>{
        return this.apiService.get(`DVMSSystemAlert/${id}`);
    }
    public checkDvmsSystemAlertByPageId(pageId:number):Observable<any>{
        return this.apiService.get(`DVMSSystemAlert/CheckDvmsSystemAlertByPageId/${pageId}`);
    }
    public ExportDvmsSystemAlertResult(dvmsSystemAlertSearchParam:IGlobalSearchParam):Observable<any> {
        return this.http.post(`${environment.apiRoot}DVMSSystemAlert/ExportDvmsSystemAlert`, dvmsSystemAlertSearchParam,
        {  
            responseType: 'blob',
            observe: 'response'
         });
      }
}